import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "" }


const __default__ = {
  name: 'BlockDisplayDetail'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String,
    required: true
  },
  subtitle: {
    type: String,
    default: ''
  },
  value: {
    type: String,
    default: ''
  },
  spaced: {
    type: Boolean,
    default: false
  },
  muted: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-md", __props.spaced ? 'space-y-2': 'space-y-1'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        __props.muted ? 'text-gray-500 text-sm' : 'font-semibold'
      ])
    }, _toDisplayString(__props.label), 3),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.subtitle), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.value), 1)
  ], 2))
}
}

})